import React, { createContext, useState } from 'react';
import Loader from "../Components/Common/Loader"
import { getLocalStorage, setLocalStorage } from './function';
// Create the context
export const WarehouseContext = createContext();

// Create the provider component
export const WarehouseProvider = ({ children }) => {
  const [selectedWarehouse, setSelectedWarehouse] = useState(
    JSON.parse(getLocalStorage('warehouse')) || null
  );
  const [warehouse, setWarehouse] = useState(
    JSON.parse(getLocalStorage('warehouse')) || null
  );

  const [shopItem, setShopItem] = useState(
    JSON.parse(getLocalStorage("SHOP")) || null
  );

  const [UserItem, setUserItem] = useState(
    JSON.parse(getLocalStorage("AuthUser"))?.user || null
  );

  const [parentCompany, setParentCompany] = useState(
    JSON.parse(getLocalStorage("ParentCompany")) || null
  );

  const [subCompany, setSubCompany] = useState(
    JSON.parse(getLocalStorage("SUB-COMPANY")) || null
  );

  const handleWarehouseSelect = (warehouse, change = false) => {
    setSelectedWarehouse(warehouse);
    setWarehouse(warehouse);
    setLocalStorage('warehouse', JSON.stringify(warehouse));
    if (change) {
      window.location.reload()
    }
  };

  const [loading, setLoading] = useState(false);
  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);

  return (
    <WarehouseContext.Provider
      value={{
        selectedWarehouse,
        warehouse,
        handleWarehouseSelect,
        loading,
        showLoader,
        hideLoader,
        shopItem,
        setShopItem,
        UserItem,
        setUserItem,
        parentCompany,
        subCompany,
        setSubCompany,
        setParentCompany
      }}
    >
      {children}
      <Loader isLoading={loading} />
    </WarehouseContext.Provider>
  );
};
